var map = {
	"./partner_1.png": 353,
	"./partner_2.png": 354,
	"./partner_3.png": 355,
	"./partner_4.png": 356,
	"./partner_5.png": 357,
	"./partner_6.png": 358,
	"./partner_7.png": 359,
	"./partner_8.png": 360
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 740;